<template>
  <div class="container-fluid pb-4 f14">
    <div class="row mb-4">
      <div class="col-lg-12 col-xs-12">
        <h4 class="color-dark-purple mt-3">EDITAR DADOS CANDIDATO(A)</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <div class="mb-3">
          <span class="ml-3 f14 font-weight-bold">NOME</span>
          <div class="mt-2">
            <input
              type="text"
              class="form-control form__input"
              v-model="candidate.name"
              minlength="4"
              required
            />
          </div>
        </div>
        <div class="mb-3">
          <span class="ml-3 f14 font-weight-bold">CELULAR</span>
          <div class="mt-2">
            <input
              class="form-control"
              type="text"
              v-model="candidate.mobile_phone"
              v-mask="'+## (##) #####-####'"
            />
          </div>
        </div>
        <div class="mb-3">
          <span class="ml-3 f14 font-weight-bold">PORTFÓLIO</span>
          <div class="mt-2">
            <input
              type="text"
              class="form-control form__input"
              placeholder="Não informado"
              v-model="candidate.personal_portfolio"
              minlength="4"
              required
            />
          </div>
        </div>
        <div class="mb-3">
          <span class="ml-3 f14 font-weight-bold">SITE PESSOAL</span>
          <div class="mt-2">
            <input
              type="text"
              class="form-control form__input"
              placeholder="Não informado"
              v-model="candidate.personal_site"
              minlength="4"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <div class="mb-3">
          <span class="ml-3 f14 font-weight-bold">EMAIL</span>
          <div class="mt-2">
            <input
              type="email"
              class="form-control"
              v-model="candidate.email"
              minlength="10"
              required
            />
          </div>
        </div>
        <div class="mb-3">
          <span class="ml-3 f14 font-weight-bold">SALÁRIO</span>
          <div class="mt-2">
            <currency-input
              v-model="candidate.remuneration"
              class="form-control"
              placeholder="0,00"
            />
          </div>
        </div>
        <div class="mb-3">
          <span class="ml-3 f14 font-weight-bold"
            >CIDADE DO(A) CANDIDATO(A)</span
          >
          <VueSuggestion
            searchURL="/cities"
            responseDataName="cities"
            :focusOut="hasCity"
            :selectedEl="city"
            :selectFirst="true"
            :clearOption="true"
            placeholder="CIDADE"
            classes="mt-2"
            inputClasses="radius-0 form-control"
          />
        </div>
        <div class="mb-3 mt-1">
          <CandidateSkills
            :candidate_id="candidate_edit.id"
            inputClasses="mt-2"
          />
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 mt-2">
        <button
          class="btn-add-items-tb bg-purple color-white right"
          style="min-width: 300px"
          @click="handleUpdate"
        >
          SALVAR
        </button>
      </div>
    </div>
  </div>
  <!--
  
  <div class="row mt-3">
    <div class="col-lg-6 col-xs-12" style="">
      <div class="mt-2">
        <div class="card talent_bank_header_white card-body">
          <div class="input mt-custom w-100">
            <span>NOME:</span>
            <input
              type="text"
              class="form-control form__input"
              v-model="name"
              minlength="4"
              required
            />
          </div>
          <div class="input mt-custom">
            <span>EMAIL:</span>
            <input
              type="email"
              class="form-control"
              v-model="email"
              minlength="10"
              required
            />
          </div>
          <div class="input mt-custom">
            <label>CELULAR</label>
            <input
              class="form-control"
              type="text"
              v-model="mobile_phone"
              v-mask="'+## (##) #####-####'"
            />
          </div>
          <div class="input mt-custom w-100">
            <span>PORTFÓLIO:</span>
            <input
              type="text"
              class="form-control form__input"
              placeholder="Não informado"
              v-model="personal_portfolio"
              minlength="4"
              required
            />
          </div>
          <div class="input mt-custom w-100">
            <span>SITE PESSOAL:</span>
            <input
              type="text"
              class="form-control form__input"
              placeholder="Não informado"
              v-model="personal_site"
              minlength="4"
              required
            />
          </div>
          <div class="input mt-custom w-100">
            <span>SALÁRIO:</span>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <b>R$</b>
                </span>
              </div>
              <currency-input
                v-model="remuneration"
                class="form-control"
                placeholder="0,00"
              />
            </div>
          </div>
          <div class="input mt-custom w-100">
            <span>STATUS:</span>
            <div class="input-group mb-2">
              <div class="input-group-prepend full">
                <select class="form-control full" v-model="status">
                  <option
                    v-for="status in this.avaiableStatus"
                    :key="status.value"
                    :value="status.value"
                  >
                    {{ status.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <button
            class="btn full btn-degrade normal-degrade mt-3"
            @click="handleUpdate"
          >
            SALVAR ALTERAÇÕES
          </button>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import axios from "axios";
import CandidateLayout from "@/Recruiters/TalentBank/Candidates/CandidateLayout.vue";
import CandidateSkills from "components/CandidateSkills.vue";
import VueSuggestion from "components/VueSuggestion.vue";

export default {
  props: ["candidate_edit"],
  components: { CandidateLayout, VueSuggestion, CandidateSkills },
  data: () => ({
    candidate: {
      name: "",
      email: "",
      personal_portfolio: "",
      personal_site: "",
      mobile_phone: "",
      remuneration: 0,
      status: "",
    },
    city: {
      id: 0,
      name: "",
    },
    avaiableStatus: [
      { text: "Desativado", value: 0 },
      { text: "Ativado", value: 1 },
    ],
  }),
  mounted() {
    this.candidate = this.candidate_edit;
    if (this.candidate_edit.city) {
      this.city = {
        id: this.candidate_edit.city.id,
        name: this.candidate_edit.city.name + "/" + this.candidate_edit.city.uf,
      };
    }

    eventBus.$on(`clearInput-cities`, () => {
      this.city = {
        id: 0,
        name: "",
      };
    });
  },
  methods: {
    hasCity(event, items) {
      this.city = items[0] ? items[0] : { id: 0, name: "" };
    },
    handleUpdate() {
      let candidates = {
        name: this.candidate.name,
        email: this.candidate.email,
        personal_portfolio: this.candidate.personal_portfolio,
        personal_site: this.candidate.personal_site,
        remuneration: this.candidate.remuneration,
        status: this.candidate.status,
        mobile_phone: this.candidate.mobile_phone,
        city_id: this.city.id,
      };

      axios
        .put(
          `/recruiters/talent_banks/${this.candidate_edit.id}/candidate/edit`,
          { candidates }
        )
        .then((response) => {
          if (response.data.updated) {
            this.$toast.success("Candidato atualizado com sucesso!");
            eventBus.$emit("updateInfo");
            this.$emit("close");
            return;
          }

          this.$toast.error("Candidato não pode ser atualizado");
        });
    },
  },
};
</script>